import { render, staticRenderFns } from "./EditSignupBannerConfiguration.vue?vue&type=template&id=8f6a217a&scoped=true"
import script from "./EditSignupBannerConfiguration.vue?vue&type=script&lang=js"
export * from "./EditSignupBannerConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EditSignupBannerConfiguration.vue?vue&type=style&index=0&id=8f6a217a&prod&scoped=true&lang=css"
import style1 from "./EditSignupBannerConfiguration.vue?vue&type=style&index=1&id=8f6a217a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a217a",
  null
  
)

export default component.exports